import { connect } from 'react-redux';
import { getAmountUnit } from 'state/secondaryMarket/cpOrder/cpOrder.utils';
import { liveOriginalFormSelectors } from 'state/secondaryMarket/live/form/original/liveOriginalForm.selector';
import { liveReferentialSelectors } from 'state/secondaryMarket/live/referential/liveReferential.selector';
import type { AppState } from 'state/state.model';

export type LivePostEventPricingInformationOwnProps = {
  tabId: string;
};
export type LivePostEventPricingInformationStateProps = {
  settlementPrice?: number;
  amountUnit: string;
  salesMarginPlusUpfront?: number;
  accruedInterest?: number;
};
export type LivePostEventPricingInformationProps = LivePostEventPricingInformationOwnProps &
  LivePostEventPricingInformationStateProps;
const mapStateToProps = (
  state: AppState,
  { tabId }: LivePostEventPricingInformationOwnProps,
): LivePostEventPricingInformationStateProps => {
  const priceType = liveReferentialSelectors.getPriceType(state, tabId)!;

  const currency = liveReferentialSelectors.getCurrency(state, tabId);

  const settlementPrice = liveOriginalFormSelectors.getFormSettlementPriceFormatted(state, tabId);

  const amountUnit = getAmountUnit(priceType, currency!);

  const salesMarginPlusUpfront = liveOriginalFormSelectors.getFormXMarginPlusUpfrontFormatted(state, tabId);
  const accruedInterest = liveOriginalFormSelectors.getFormAccruedInterestFormatted(state, tabId);

  return { amountUnit, accruedInterest, salesMarginPlusUpfront, settlementPrice };
};

export const connectLivePostEventPricingInformation = connect(mapStateToProps);
